import React from "react";
import "./ProfileSidebar.scss";

// import Avatar from "components/Avatar";
// import Button from "components/Button";
import LinkItem from "components/LinkItem";

import ProfileHeader from "./ProfileHeader";

const ProfileSidebar = ({ user, isMyProfile, loaded }) => {
  const workHistory = user.workHistory
    ? user.workHistory.slice(0).reverse()
    : null;
  return (
    <div className="ProfileSidebar" data-loaded={loaded}>
      <ProfileHeader loaded={loaded} isMyProfile={isMyProfile} user={user} />
      <div className="skills">
        {user.skills && user.skills.length > 0 && <h6>Skills</h6>}
        <ul>
          {user.skills &&
            user.skills.map((skill, i) => <li key={i}>{skill.label}</li>)}
        </ul>
      </div>
      <div className="workhistory">
        {workHistory && workHistory.length > 0 && (
          <>
            <h6>Work History</h6>
            <ul>
              {workHistory.map((workHistoryItem, i) => (
                <li key={i}>
                  <strong>{workHistoryItem.position}</strong>
                  {workHistoryItem.organization} - {workHistoryItem.location}
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
      <div className="links">
        {user.links && user.links.length > 0 && <h6>Links</h6>}
        {user.links &&
          user.links.map((link, i) => <LinkItem key={i} {...link} />)}
      </div>
    </div>
  );
};
export default ProfileSidebar;
